import axios from '@/utils/axios.js'
import Cookies from 'js-cookie'
import {Message} from 'element-ui'
export function getPortalToken() {
  return new Promise((resolve, reject) => {
    axios.get('/portal/vue/YfPortalOtherServlet', {
      params: {
        action: 'getPortalToken'
      }
    }).then(result => {

      if(typeof result ==='string'){
        Cookies.set('portalToken',result)
        resolve()
      }else{
        if(result.code==1){
          Cookies.set('portalToken',result.token)
          resolve()
        }else{
          message.error('无法获得portalToekn，无法获得数据')
        }
      }
      
     
    })
  })
}

export function webInfo() {
  return new Promise((resolve, reject) => {
    axios.get('/portal/vue/YfPortalServlet', {
      params: {
        "action": "WebView"
      }
    }).then(result => {
      resolve(result)
    })
  })
}

//新的
export function login({userName="",userPwd="",yfRand=""}){
  return new Promise((resolve, reject)=>{
    axios.post('/school/weixinapp/YfTokenServlet', {
      actionServlet:'YfLogin',userName,userPwd,yfRand
    }).then(result=>{
      if(result.code==1){
        resolve(result)
      }else{
        Message.error(result.msg)
      }
    })
  }) 

}


//旧的
// export function login({
//   userName = "",
//   userPwd = "",
//   yfRand=""
// }) {

//   return new Promise((resolve,reject)=>{
//     $.ajax({  
//       type : "POST",  //提交方式  
//       url : process.env.NODE_ENV==='development'?process.env.VUE_APP_SECRET:location.origin+"/portal/vue/YfPortalServlet",//路径  
//       dataType:"JSON",
//       data : {  
//         action: 'LoginUser',
//         userName,
//         userPwd,yfRand
//       },//数据，这里使用的是Json格式进行传输  
//       success : function(result) {//返回数据根据结果进行相应的处理 
//         resolve(result) 
//       }  
//   });  
//   })

// }





//旧的
// export function outLogin() {
//   Cookies.remove('SLCOOKIE')
// }





//新的
export function outLogin() {
  Cookies.remove('YFCOOKIE')
}

//新的
export function getUserInfo(){
  return new Promise((resolve, reject)=>{
    axios.get('/school/weixinapp/YfTokenServlet', {
      params:{
        actionServlet:'token',token:Cookies.get('YFCOOKIE')||''
      }
    }).then(result=>{
      resolve(result)
    })

  }) 
}
//旧的
// export function getUserInfo() {
//   const sl = Cookies.get('SLCOOKIE')
//   return new Promise((resolve, reject) => {
//     if (sl) {
//       axios.post('/portal/vue/YfPortalServlet', {
//         action: 'SLCOOKIE',
//         yfCookie: sl
//       }).then(result => {
//         resolve(result)
//       })
//     }
//   })
// }




//新的
export function auth(){
  return new Promise((resolve,reject)=>{
    axios.get('/school/weixinapp/YfTokenServlet', {
      params: {
        actionServlet:'auth'
      }
    }).then(result => {
      if(result.auth==1){
          resolve({code:1,img:(process.env.NODE_ENV==='development'?process.env.VUE_APP_SECRET:location.origin)+"/school/YfAuthImg?now="+Date.parse(new Date())})
      }else{
          resolve({code:0,img:(process.env.NODE_ENV==='development'?process.env.VUE_APP_SECRET:location.origin)+"/school/YfAuthImg?now="+Date.parse(new Date())})
      }
    })
  })
}



//旧的 待确认

// export function auth(){
//   return new Promise((resolve,reject)=>{
//     axios.get('/portal/vue/YfPortalServlet', {
//       params: {
//         action:'authFlg'
//       }
//     }).then(result => {
//       if(result.code==1){
//           resolve({code:1,img:(process.env.NODE_ENV==='development'?process.env.VUE_APP_SECRET:location.origin)+"/portal/YfAuthImg?now="+Date.parse(new Date())})
//       }else{
//           resolve({code:0,img:(process.env.NODE_ENV==='development'?process.env.VUE_APP_SECRET:location.origin)+"/portal/YfAuthImg?now="+Date.parse(new Date())})
//       }
//     })
//   })
// }



//旧的
// export function getAuthImg(){
//   // return process.env.VUE_APP_SECRET+"/school/YfAuthImg?now="+Date.parse(new Date())
//   return (process.env.NODE_ENV==='development'?process.env.VUE_APP_SECRET:location.origin)+"/portal/YfAuthImg?now="+Date.parse(new Date())
// }


// 新的
export function getAuthImg(){
  return (process.env.NODE_ENV==='development'?process.env.VUE_APP_SECRET:location.origin)+"/school/YfAuthImg?now="+Date.parse(new Date())
}





export function getMenuMain() {
  return new Promise((resolve, reject) => {
    axios.get('/portal/vue/YfPortalServlet', {
      params: {
        action: 'WebMenu'
      }
    }).then(result => {
      resolve(result)
    })
  })
}


export function getSelectLinks(typeId, rowNum) {
  return new Promise((resolve, reject) => {
    axios.get('/portal/vue/YfPortalServlet', {
      params: {
        action: 'Index',
        typeId: typeId,
        rowNum: rowNum
      }
    }).then(result => {
      const data = result.data[0].dt || []
      let promiseList = []
      if (data.length > 0) {
        data.forEach((element, i) => {
          promiseList[i] = axios.get('/portal/vue/YfPortalServlet', {
            params: {
              action: 'Article',
              articleId: element.article_id
            }
          })
        })
        Promise.all(promiseList).then(results => {
          let list = []
          results.forEach(e => {
            list.push({
              title: e.data.dt[0].title || '',
              links: e.data.http_link || [],
            })
          })
          resolve(list);
        })
      }
    })

  })
}